import { over } from "lodash";
import { z, ZodType } from "zod";
import { AircraftType } from "../../../globals/interfaces";
import { dateString, nullableNumber, numericString, optional, ZodEntriesOf } from "../../../utils";

export const AircraftTypeSchema = z.object({
    id: optional(z.number()),
    FAA_Designator: z.string().min(1, "FAA Designator is required"),
    Manufacturer: z.string().min(1, "Manufacturer is required"),
    Model_FAA: z.string().min(1, "Model (FAA) is required"),
    Model_BADA: z.string().min(1, "Model (BADA) is required"),
    Physical_Class_Engine: z.string().min(1, "Engine Class is required"),
    Num_Engines: z.number().min(1, "Number of engines must be at least 1"),
    MTOW: optional(numericString('')),
    MALW: optional(numericString('')),
    ICAO_WTC: optional(z.string()),
    Class: optional(z.string()),
    FAA_Weight: optional(z.string()),
    created: dateString,
    createdBy: z.string().email("Created By must be a valid email"),
    modified: dateString,
    modifiedBy: z.string().email("Modified By must be a valid email"),
});

export const AircraftTypeSchemaUpdate = AircraftTypeSchema.extend({
    id: z.number().min(1, "ID is required")
});

